import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../pagini/Firebase";
import geoData from "./Assets/romania-counties.json";
import sectorData from "./Assets/bucharest-sectors.json";
import "./Stiluri/RapoarteHeatmap.css";

const RapoarteHeatmap = () => {
  const [geoJson, setGeoJson] = useState(null);
  const [sectorGeoJson, setSectorGeoJson] = useState(null);
  const [popupInfo, setPopupInfo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snapshot = await getDocs(collection(db, "Beneficiari"));

        const judetCounts = {};
        const sectorCounts = {};

        snapshot.forEach((doc) => {
          const loc = doc.data().ultimaLocatie?.judet;
          if (!loc) return;

          if (loc.startsWith("Sector")) {
            // București – sectoare
            sectorCounts[loc] = (sectorCounts[loc] || 0) + 1;
          } else {
            // Restul județelor
            judetCounts[loc] = (judetCounts[loc] || 0) + 1;
          }
        });

        // Actualizare geoJson pentru județe reale
        const updatedFeatures = geoData.features.map((feature) => {
          const judetName = feature.properties.name;
          return {
            ...feature,
            properties: {
              ...feature.properties,
              cases: judetCounts[judetName] || 0,
            },
          };
        });
        setGeoJson({ ...geoData, features: updatedFeatures });

        // Actualizare geoJson pentru sectoare București
        const updatedSectors = sectorData.features.map((feature) => {
          const name = feature.properties.name;
          return {
            ...feature,
            properties: {
              ...feature.properties,
              cases: sectorCounts[name] || 0,
            },
          };
        });
        setSectorGeoJson({ ...sectorData, features: updatedSectors });
      } catch (error) {
        console.error("Eroare la încărcarea datelor:", error);
      }
    };

    fetchData();
  }, []);

const getColor = (cases) => {
  if (cases === 0) return "#31a354"; // gri pentru 0 cazuri
  return cases > 400
    ? "#800026"
    : cases > 300
    ? "#BD0026"
    : cases > 200
    ? "#E31A1C"
    : cases > 100
    ? "#FC4E2A"
    : cases > 50
    ? "#FD8D3C"
    : "#31a354"; // verde mai deschis pentru 1-50
};


  const style = (feature) => ({
    fillColor: getColor(feature.properties.cases),
    weight: 1,
    opacity: 1,
    color: "white",
    dashArray: "3",
    fillOpacity: 0.7,
    cursor: "pointer",
  });

  const onEachFeature = (feature, layer) => {
    if (feature.properties?.name) {
      layer.bindTooltip(
        `${feature.properties.cases}`,
        { permanent: true, direction: "center", className: "county-tooltip" }
      );
      layer.on("click", (e) => {
        setPopupInfo({
          name: `${feature.properties.name}: ${feature.properties.cases}`,
          latlng: e.latlng,
        });
      });
    }
  };

  return (
    <div>
      <div
        style={{
          background: "white",
          padding: "1.5rem",
          borderRadius: "8px",
          marginBottom: "1rem",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h2 style={{ margin: 0 }}>Harta termică a cazurilor pe județe</h2>
          <p style={{ color: "#555", maxWidth: "800px", margin: "0 auto" }}>
            Această hartă evidențiază distribuția numărului de beneficiari pe
            județe și sectoarele Bucureștiului. Apasă pe un județ/sector pentru
            detalii.
          </p>
        </div>
      </div>

      <div style={{ height: "600px", width: "100%" }}>
        <MapContainer
          center={[45.9432, 24.9668]}
          zoom={7}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; OpenStreetMap contributors'
          />
          {geoJson && (
            <GeoJSON data={geoJson} style={style} onEachFeature={onEachFeature} />
          )}
          {sectorGeoJson && (
            <GeoJSON data={sectorGeoJson} style={style} onEachFeature={onEachFeature} />
          )}
          {popupInfo && (
            <Popup position={popupInfo.latlng} onClose={() => setPopupInfo(null)}>
              <div style={{ fontWeight: "bold" }}>{popupInfo.name}</div>
            </Popup>
          )}
        </MapContainer>
      </div>
    </div>
  );
};

export default RapoarteHeatmap;
